export const environment = {
  production: true,
  inBrowser: false,
  name: 'prod',
  aem: '', // host AEM
  api: 'https://dxl.vodafone.it', // host API
  apiKeycloak: 'https://keycloak.dxl.vodafone.it', // host API keycloak
  apiBasePath: 'api-biz',
  resource: '/etc.clientlibs/myvf-business/clientlibs/myvf-business-webview/resources',
  apiAWS: 'https://business.api.mvacloud.vodafone.it/prod',
  aemBasePath:'https://mva-business.vodafone.it'
};
